import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import TableFilterBox from "../organisms/TableFilterBox";
import TableHeader from "../organisms/TableHeader";
import TableFooter from "../organisms/TableFooter";
import styled from "styled-components";
import DataTable from "./DataTable";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DatepickerRange from "../molecules/DatepickerRange";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import TablePagination from "../molecules/TablePagination";
import axios from "axios";
import SelectBox from "../molecules/SelectBox";
import { useSelector } from "react-redux";

const TableWrap = styled.div`
    flex: 1 1;
    display: flex;
    flex-direction: column;

    .data-table {
        flex-grow: 1;
    }
`;

export default function CompanyManagement() {
    const location = useLocation();
    const navigate = useNavigate();

    const perPageOptions = useSelector(state => state.perPageOptions);
    const loginInfo = useSelector(state => state.login);

    const defaultDate = ["",""];
    const defaultFilter = {
        "orderField": "registerTime",
        "order": "desc",
        "page": 1,
        "perPage": perPageOptions[0].value,
        "companyName": "",
        "startDate": defaultDate[0],
        "endDate": defaultDate[1]
    };
    const [tableData, setTableData] = useState({
        orderField: ["company", "branchCount", "branch", "registerTime"],
        head: ["업체명", "지점 수", "지점명", "등록일시"],
        body: [],
    });
    const [dataTotal, setDataTotal] = useState(0);
    const [filter, setFilter] = useState(localStorage.getItem("digilog_cFilter") ? JSON.parse(localStorage.getItem("digilog_cFilter")) : defaultFilter);
    const [startDate,setStartDate] = useState(filter.startDate);
    const [endDate, setEndDate] = useState(filter.endDate);
    
    const filterCompanyNameRef = useRef();
    
    const {isError, isLoading, refetch, isRefetching} = useQuery({
        queryKey: ['getCompanyList'],
        queryFn: () => {
            return axios("/company/list", {
                method: "POST",
                data: filter
            }).then(result => {
                const tbodyDataArr = [];
                result.data.data.list.forEach((el, idx) => {
                    tbodyDataArr.push([
                        <Link 
                            to={"/admin/detail/company/" + el.companyId}
                            onClick={() => {
                                localStorage.setItem("digilog_cFilter", JSON.stringify(filter));
                            }}>
                                {el.companyName}
                        </Link>, 
                        el.branch.count, 
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip style={{ fontSize: "12px", position: "fixed" }}>
                                    {el.branch.branchList.toString()}
                                </Tooltip>
                            }
                        >
                            <div className="text-ellipsis m-auto" style={{maxWidth: "400px"}}>
                                {el.branch.branchList.toString()}
                            </div>
                        </OverlayTrigger>, 
                        el.registerTime
                    ]);
                });
                
                setTableData({
                    ...tableData,
                    total: result.data.data.total,
                    body: tbodyDataArr
                });
                setDataTotal(result.data.data.total);

                return result.data;
            })
        },
        enabled: false
    });

    useEffect(() => {
        refetch();
    },[filter]);

    useEffect(() => {
        localStorage.removeItem("digilog_cFilter");
    },[]);

    useEffect(() => {
        if (loginInfo.admin.level) {
            if (loginInfo.admin.level > 2) {
                navigate("/error/accessDenied")
            }
        }
    },[loginInfo]);

    useEffect(() => {
        refetch();
    },[location])

    return (
        <>
            <TableFilterBox 
                handleClickReset={() => {
                    filterCompanyNameRef.current.value ="";
                    setStartDate(defaultDate[0]);
                    setEndDate(defaultDate[1]);
                    setFilter({
                        ...filter,
                        page: 1,
                        companyName: "",
                        startDate: defaultDate[0],
                        endDate: defaultDate[1]
                    });
                }}

                handleClickSubmit={() => {
                    setFilter({
                        ...filter,
                        page: 1,
                        companyName: filterCompanyNameRef.current.value,
                        startDate: startDate,
                        endDate: endDate
                    });
                }}
            >
                <Row className="justify-content-between">
                    <Col sm={6} xxl={5}>
                        <Form.Group as={Row}>
                            <Form.Label column sm={2} xxl={3}>
                                업체명
                            </Form.Label>
                            <Col sm={10} xxl={9}>
                                <Form.Control defaultValue={filter.companyName} ref={filterCompanyNameRef} type="text" placeholder="업체명을 입력하세요." 
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/g, "");
                                }} />  
                            </Col>
                        </Form.Group>
                    </Col>

                    <Col sm={6} xxl={5}>
                        <Form.Group as={Row}>
                            <Form.Label column sm={2} xxl={3}>
                                등록일
                            </Form.Label>
                            <Col sm={10} xxl={9}>
                                <DatepickerRange startDate={filter.startDate} endDate={filter.endDate} onChange={(dates) => {
                                    setStartDate(dates[0]);
                                    setEndDate(dates[1]);
                                }} />
                            </Col>
                        </Form.Group>
                    </Col>
                </Row>
            </TableFilterBox>

            
            <TableWrap className="mt-4">
                <TableHeader total={dataTotal}>
                    
                    <div style={{width: "200px"}}>
                        <SelectBox 
                            onChange={(value) => {
                                setFilter({
                                    ...filter,
                                    page: 1,
                                    perPage: value.value
                                })
                            }} 
                            className="w-auto"
                            defaultValue={filter.perPage}
                            data={perPageOptions}
                        />
                    </div>

                    <TableHeader.ButtonBox>
                        {
                            loginInfo.admin.level == 1 &&
                            <Link to="/admin/add/company" className="btn-primary btn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                                </svg>
                                신규 등록
                            </Link>
                        }
                    </TableHeader.ButtonBox>
                </TableHeader>

                <DataTable isError={isError} isLoading={isLoading || isRefetching} data={tableData} useNo={true}
                            sort={[3]} activeSortIdx={3}  handleClickSort={(idx, type) => {
                                setFilter({
                                    ...filter,
                                    orderField: tableData.orderField[idx],
                                    order: type,
                                })
                            }} />

                <TableFooter>
                    <TablePagination 
                        total={dataTotal} 
                        perPage={filter.perPage} 
                        currentPage={filter.page}
                        onChange={(value) => {
                        setFilter({
                            ...filter,
                            page: value
                        })
                    }}/>
                </TableFooter>
            </TableWrap>
        </>
    );
}
